import { TextField } from '@deque/cauldron-react';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { TemplateFormFields } from '~/app/types';
import styles from './Field.css';

export const SummaryPrefixInput = () => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors }
  } = useFormContext<TemplateFormFields>();

  return (
    <div className={styles.summaryPrefixInput}>
      <Controller
        name="summaryPrefix"
        control={control}
        aria-labelledby="summary-prefix"
        render={({ field: { ref, ...field } }) => (
          <TextField
            {...field}
            id="summary-prefix"
            label={t('Summary prefix')}
            error={errors.summaryPrefix?.message}
            fieldRef={ref}
          />
        )}
      />
    </div>
  );
};
